// AUTO GENERATED FILE - Changes WILL be lost.
// hr - used as 'hr' fallback
export const common_fallback = true

export const translations = {}
